import { Button, Flex } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { useShallow } from "zustand/react/shallow"
import { Alert, Text } from "~/components"
import { useHotVideoStore } from "~/store/hotVideo"

export const ScriptSaveStatus = () => {
  const {
    scriptSaveStatus,
    scriptSaveError,
    saveReplicaPrompt,
    canSaveScript,
    hasEditedScript,
    isSubmittingVideoTask,
  } = useHotVideoStore(
    useShallow((state) => ({
      scriptSaveStatus: state.scriptSaveStatus,
      scriptSaveError: state.scriptSaveError,
      saveReplicaPrompt: state.saveReplicaPrompt,
      canSaveScript: state.canSaveScript,
      hasEditedScript: state.hasEditedScript,
      isSubmittingVideoTask: state.isSubmittingVideoTask,
    })),
  )
  if (
    isSubmittingVideoTask ||
    (scriptSaveStatus === "idle" && (canSaveScript || !hasEditedScript))
  )
    return null

  return (
    <Flex
      aria-live="polite"
      style={{ marginBottom: 16 }}
      vertical
    >
      {!canSaveScript && hasEditedScript ? (
        <Text
          type="secondary"
          size="s"
        >
          当前任务状态不支持自动保存，修改内容将在生成视频时提交
        </Text>
      ) : scriptSaveStatus === "error" ? (
        <Alert
          level="strong"
          showIcon
          title="脚本自动保存失败，修改内容尚未保存"
          description={scriptSaveError}
          action={
            <Button
              size="small"
              onClick={() => void saveReplicaPrompt()}
            >
              重试保存
            </Button>
          }
        />
      ) : (
        <Text
          type="secondary"
          size="s"
        >
          {scriptSaveStatus === "saving" ? <LoadingOutlined /> : null}{" "}
          {scriptSaveStatus === "saved"
            ? "已自动保存"
            : scriptSaveStatus === "saving"
              ? "正在保存…"
              : "待保存，离开输入框后自动保存"}
        </Text>
      )}
    </Flex>
  )
}
